import { DefaultState } from 'store/types';

export const GET_CORPORATE_CLIENTS_REQUEST = 'GET_CORPORATE_CLIENTS_REQUEST';
export const GET_CORPORATE_CLIENTS_SUCCESS = 'GET_CORPORATE_CLIENTS_SUCCESS';
export const GET_CORPORATE_CLIENTS_FAILURE = 'GET_CORPORATE_CLIENTS_FAILURE';


export interface GetCorporateClientsParams {
  filters?: {
    usage?: string;
  };
  paging: {
    page: number;
    pageSize: number;
  };
  sorting: {
    id: string;
    order: string;
  };
}

export interface CorporateClientBaseData {
  id: string;
  name: string;
  inRequestsCount: number;
  inReservationsCount: number;
}

export interface GetCorporateClientsRow extends CorporateClientBaseData { }

export interface GetCorporateClientRow extends CorporateClientBaseData {
  id: string;
  name: string;
  inRequestsCount: number;
  inReservationsCount: number;
}

export interface GetCorporateClientsData {
  rows: GetCorporateClientsRow[];
  totalCount: number;
}

export type GetCorporateClientsState = DefaultState & {
  contents?: GetCorporateClientsData;
};

interface GetCorporateClientsRequest {
  type: typeof GET_CORPORATE_CLIENTS_REQUEST;
}

interface GetCorporateClientsSuccess {
  type: typeof GET_CORPORATE_CLIENTS_SUCCESS;
  contents: GetCorporateClientsData;
}

interface GetCorporateClientsFailure {
  type: typeof GET_CORPORATE_CLIENTS_FAILURE;
}

export type GetCorporateClientsActionTypes = GetCorporateClientsRequest | GetCorporateClientsSuccess | GetCorporateClientsFailure;